export interface IContainerSDK {
  /** 创建会议成功手动执行 */
  createMeetingSuccess: (meetingNo: string) => void
  /** 取消创建会议 */
  cancelCreateMeeting: () => void
  /** 进入会议编辑 */
  editMeeting:(meetingNo:string, query?: string) => void
  /** 编辑成功回调 */
  editMeetingSuccess: (meetingNo: string) => void
  /** 取消编辑回调 */
  cancelEditMeeting: (meetingNo: string) => void
  /** 取消预约的会议后手动执行，用于MLapp列表同步删除会议 */
  cancelMeetingSuccess:(meetingNo: string) => void
}

/** 预留拓展 */
class ThirtPartContainer {
  public sdk?: IContainerSDK

  public provideSDK(sdk: IContainerSDK) {
    this.sdk = sdk;
  }
}

const thirtPartContainer = new ThirtPartContainer();

export default thirtPartContainer;
